/**
 * Resting About-Elite FAB layout numbers shared by the FAB and the clear-of-band hook.
 *
 * Belongs here: gap, chip size, safe-area helpers, viewport slot.
 * Does not belong here: FAB UI, scroll observers.
 */
import { getBottomPadding } from '../../utils/sessionStorage'

/** Gap between FAB bottom and sticky CTA / safe area — keep in sync with resting `bottom` style. */
export const ELITE_ABOUT_FAB_GAP_PX = 20
/** Portrait circle size inside the FAB chip. */
export const ELITE_ABOUT_FAB_PORTRAIT_PX = 48
/** Tailwind `py-1.5` on the FAB chip (top + bottom). */
export const ELITE_ABOUT_FAB_PADDING_Y_PX = 12
/** Resting chip height derived from portrait + vertical padding. */
export const ELITE_ABOUT_FAB_HEIGHT_PX = ELITE_ABOUT_FAB_PORTRAIT_PX + ELITE_ABOUT_FAB_PADDING_Y_PX

export function readEliteAboutFabSafeBottomPx(): number {
  try {
    const padding = getBottomPadding({ includeExtraPadding: false })
    return Number.isFinite(padding) ? padding : 0
  } catch {
    return 0
  }
}

/**
 * Distances from the viewport bottom to the resting FAB chip (matches `bottom` + height).
 * Same numbers for first paint and scroll.
 */
export function getEliteAboutFabViewportSlot(): {
  fabTopFromViewportBottom: number
  fabBottomFromViewportBottom: number
} {
  const safeBottomPx = readEliteAboutFabSafeBottomPx()
  const fabBottomFromViewportBottom = safeBottomPx + ELITE_ABOUT_FAB_GAP_PX
  return {
    fabBottomFromViewportBottom,
    fabTopFromViewportBottom: fabBottomFromViewportBottom + ELITE_ABOUT_FAB_HEIGHT_PX
  }
}
